module.exports = __webpack_public_path__ + "static/media/grid-metro-12.ac78f581.jpg";